const $ = jQuery.noConflict();

const mobileMenu = () => {
	// Cache DOM
	const body = $('body');
	const $document = $(document);
	const header = $('header.header');
	const menuTrigger = header.find('.header__mobile-btn');
	const menuItems = header.find('.header__nav > ul > li > a');

	// Bind events
	menuTrigger.on('click', () => {
		body.toggleClass('menu-opened');
	});

	menuItems.on('click', () => {
		body.removeClass('menu-opened');
	});

	$document.on('click touchstart', (e) => {
		if (!$(e.target).closest('.header__nav').length && !$(e.target).closest('.header__mobile-btn').length && body.hasClass('menu-opened')) {
			body.removeClass('menu-opened');
		}
	});
};

export default mobileMenu;
